/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-05-01 14:30:33
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-07-19 16:15:06
 * @FilePath     : /marketing-landing-fe/src/plugins/Drawer/index.ts
 * @Description  : 未添加文件描述
 */
import { addClass } from '@/utils/dom'; // 插入弹窗

export var appendDrawer = function appendDrawer(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.content,
      content = _c === void 0 ? '' : _c,
      onClose = _a.onClose,
      onMount = _a.onMount,
      _d = _a.id,
      id = _d === void 0 ? 'j-drawer' : _d,
      body = _a.body,
      closeClassName = _a.closeClassName,
      _e = _a.backgroundClose,
      backgroundClose = _e === void 0 ? false : _e,
      contentCustomAppendDom = _a.contentCustomAppendDom;
  var $body = body || document.body;
  var oldDrawer = document.getElementById(id);

  if (oldDrawer) {
    $body.removeChild(oldDrawer);
  }

  var $content = document.createElement('div');
  $content.id = id;

  if (body) {
    addClass($content, "drawer ".concat(className));
    $content.innerHTML = content;
  } else {
    var $close_1;
    addClass($content, "ui-drawer ".concat(className));
    $content.innerHTML = content;

    if (!closeClassName) {
      $close_1 = document.createElement('i');
      addClass($close_1, 'ui-icon ui-icon-close');
      $content.children[0].appendChild($close_1);
    } else {
      $close_1 = $content.querySelector(closeClassName);
    }

    if ($close_1) {
      $close_1.onclick = function (e) {
        e.stopPropagation();

        if (typeof onClose === 'function') {
          onClose();
        }

        if ($close_1) {
          $close_1.onclick = null;
        }

        $content.onclick = null;
        $body.removeChild($content);
      };
    }

    if (backgroundClose) {
      $content.addEventListener('click', function (e) {
        e.stopPropagation();
        var ev = e || window.event;
        ev.stopPropagation();
        var target = ev.target || ev.srcElement;

        if (target === $content) {
          if (typeof onClose === 'function') {
            onClose();
          }

          if ($close_1) {
            $close_1.onclick = null;
          }

          $content.onclick = null;
          $body.removeChild($content);
        }
      }, false);
    }
  } // SP101 新增 自定义弹窗内容 2023-07-19 16:15:06


  if (contentCustomAppendDom) {
    var $contentWrapper = $content.querySelector('.content');

    if ($contentWrapper) {
      $contentWrapper.appendChild(contentCustomAppendDom);
    }
  }

  $body.appendChild($content);

  if (typeof onMount === 'function') {
    onMount($content);
  } // bind($content, $close);


  return $content;
};